export const OTHER_ACCOUNT_ID_FIELD_NAME = 'otherAccountId';
